"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ElitePerformanceShowcase() {
  const [scrollY, setScrollY] = useState(0);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);
  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const headlineLines = ["Master", "Your", "Game."];
  return <section data-section-id="176" id="elite-performance-showcase" className="relative h-screen min-h-[700px] w-full overflow-hidden bg-background text-foreground !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1702891/img/Color-logo-with-background-scaled.png)]">
      {}
      <div className="absolute inset-0 z-0" style={{
      transform: `translateY(${scrollY * 0.3}px)`
    }}>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1702891/img/Color logo with background.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1702891/img/Color logo with background.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1702891/img/Color logo with background.png-wvc-sizes" alt="ICECAMP Elite Performance" loading="lazy" decoding="async" className="h-full w-full object-cover" />
      </div>

      {}
      <div className="absolute inset-0 z-10 pointer-events-none" style={{
      background: "linear-gradient(225deg, hsla(220, 15%, 4%, 0.9) 0%, hsla(220, 15%, 4%, 0.6) 45%, hsla(220, 15%, 4%, 0.8) 100%)"
    }} />

      {}
      <div className="absolute inset-0 z-20 pointer-events-none opacity-[0.12] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
      backgroundSize: "200px 200px"
    }} />

      {}
      <div className="relative z-30 flex h-full flex-col justify-between px-6 py-8 md:px-12 md:py-12 lg:px-16">
        {}
        <div className={`font-mono text-[10px] md:text-xs uppercase tracking-[0.2em] text-foreground/70 transition-all duration-1000 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"}`}>
          <span className="mr-2">—</span>
          ICECAMP / ELITE HOCKEY DEVELOPMENT
        </div>

        {}
        <div className="flex-1 flex flex-col justify-center max-w-[1400px]">
          <h1 className="font-default font-light leading-[0.85] mb-8 md:mb-10" style={{
          fontSize: "clamp(4rem, 12vw, 12rem)",
          letterSpacing: "-0.04em"
        }}>
            {headlineLines.map((line, i) => <span key={i} data-index={i} className="block overflow-hidden">
                <span className={`block transition-transform ease-out ${loaded ? "translate-y-0" : "translate-y-full"}`} style={{
              transitionDuration: "1100ms",
              transitionDelay: `${200 + i * 180}ms`
            }}>
                  {line === "Your" ? <span className="inline-block !h-[125.242px]" style={{
                WebkitTextStroke: "1.5px hsl(210 20% 98%)",
                color: "transparent"
              }}>your </span> : <span className="inline-block">{line}</span>}
                </span>
              </span>)}
          </h1>

          <p className={`font-default text-base md:text-lg max-w-2xl text-foreground/70 mb-10 transition-all duration-1000 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "900ms"
        }}>Refinement is the key to greatness in our sport....It has been said that it takes 10,000 perfect repetitions to master any hockey skill. Start building your hockey mastery in a week with me this June 22-26</p>

          <div className={`flex flex-col sm:flex-row gap-4 transition-all duration-1000 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "1100ms"
        }}>
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-mono uppercase tracking-[0.18em] text-xs px-8 h-12">
              <Link to="/Registration">Register Now</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="bg-transparent border-foreground/40 text-foreground hover:bg-foreground hover:text-background font-mono uppercase tracking-[0.18em] text-xs px-8 h-12">
              
            </Button>
          </div>
        </div>

        {}
        <div className="flex items-end justify-between gap-4">
          <div className="font-mono text-[10px] md:text-xs uppercase tracking-[0.2em] text-foreground/70 flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full bg-accent-foreground opacity-75 animate-ping" />
                <span className="relative inline-flex h-2 w-2 bg-accent-foreground" />
              </span>
              <span>LIVE REGISTRATION</span>
            </div>
            <div className="text-foreground/50">
              $675 / FULL SESSION
            </div>
          </div>

          <div className="flex flex-col items-center gap-3 text-foreground/60">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em]" style={{
            writingMode: "vertical-rl"
          }}>
              (Scroll)
            </span>
            <div className="relative h-16 w-px overflow-hidden bg-foreground/20">
              <span className="absolute left-0 top-0 h-full w-full bg-foreground" style={{
              animation: "scrollLine 2s ease-in-out infinite"
            }} />
            </div>
            <ArrowDown className="h-3 w-3" strokeWidth={1} />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          50% { transform: translateY(0); }
          100% { transform: translateY(100%); }
        }
      `}</style>
    </section>;
}